<template>
  <AdventureLand />
</template>

<script>
import AdventureLand from "@/components/AdventureLand";

export default {
  name: 'App',
  components: {
    AdventureLand
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
#app {
  font-family: "Courier New";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #20e020;
  background-color: black;
  width: 100vw;
  height: 100vh;
  text-align: left;
}
</style>
